<template>
  <div class="footer">
    <div class="footer-box">
      <p>公司地址：{{config.companyAddress}}</p>
      <p>官方网站：{{config.officialWebsite}}</p>
      <p>咨询电话：{{config.hotline}}</p>
      <p>邮箱：{{config.mailbox}}</p>
      <p>沪ICP备2023033453号-1</p>
      <a href="https://beian.miit.gov.cn/#/Integrated/index">{{config.archivalInformation}}</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['config'])
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .footer {
    width: 100%;
    background-color: #2474cf;
    &-box {
      color: #fff;
      font-size: 18px;
      line-height: 35px;
      width: 1200px;
      margin: auto;
      background-color: #2474cf;
      padding: 30px 0;
      display: flex;
      flex-direction: column;
    }
    a {
      color: #fff;
      font-size: 14px;
      text-align: center;
    }
  }
</style>
